import { call, put, select, takeLatest } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { INIT_REGISTER_USER, REGISTER_USER, registerActions, registerSelectors } from '../reducer/register-reducer';
import { getUnregisteredUserInfo, registerUserWithEgo } from '../services/register-helpers';
import { appActions, LOG_LEVEL, TRANSACTION_STATE } from '../../app/reducer/app-reducer';

function* initUserRegistration(action) {
  try {
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.PENDING));
    yield put(appActions.logoutUser());
    const userRegistrationInfo = yield call(getUnregisteredUserInfo, action.payload.userId);
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.SUCCESS));
    if (userRegistrationInfo.status === 'NOT_REGISTERABLE') {
      return yield put(push('/login'));
    }
    yield put(appActions.setInterfaceLanguage(userRegistrationInfo.interfaceLanguage));
    return yield put(registerActions.setUserRegistrationInfo(userRegistrationInfo));
  } catch (ex) {
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.FAIL));
  }
}

function* registerUser(action) {
  const userId = action.payload.userId;
  const registrationInfo = action.payload.registrationInfo;
  try {
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.PENDING));
    const userRegInfo = yield select(registerSelectors.userRegistrationInfo);
    const userName = userRegInfo.email;
    yield call(registerUserWithEgo, userId, registrationInfo);
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.SUCCESS));
    yield put(appActions.consolidatedLoginUser(userName, registrationInfo.password, '', ''));
  } catch (ex) {
    let errorMsg = 'error registering user: ' + ex.message;
    yield put(
      appActions.logEvent({
        level: LOG_LEVEL.ERROR,
        message: errorMsg
      })
    );
    return yield put(appActions.setLastTransactionState(TRANSACTION_STATE.FAIL, errorMsg));
  }
}

export function* registerSagas() {
  yield takeLatest(INIT_REGISTER_USER, initUserRegistration);
  yield takeLatest(REGISTER_USER, registerUser);
}



// WEBPACK FOOTER //
// ./src/modules/register/sagas/register-sagas.js